import styled from "styled-components";
import { Button } from "src/components";

export const PanelContainer = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 42rem) minmax(0, 28rem);
    width: 100%;

    @media (max-width: 980px) {
        grid-template-columns: 1fr;
    }

    & div.spacing-x {
        padding-right: 40px;
        padding-left: 40px;
    }

    & div.spacing-y {
        padding-top: 30px;
        padding-bottom: 40px;
    }
`;

export const LeftPanel = styled.div`
    border-right:1px solid #D8DEEC;
    width: 100%;
    min-width: 0;
    
    & div.borderBottom {
        border-bottom: 1px solid #D8DEEC
    }

    & div.maxWidth {
        max-width: 100%;
    }

    & div.maxWidth-680 {
        max-width: 100%;
    }

    @media (max-width: 980px) {
        border-right: none;
        border-bottom: 1px solid #D8DEEC;
    }
        
`;

export const RightPanel = styled.div`
    text-align: center;
    min-width: 0;
`;

export const CustomizeButton = styled(Button)`
    padding: 10px 0 !important;
    border-radius: 8px !important;
    background-color: ${p => p.backgroundColor || "#FFF" };
    color: ${p => p.color || "#171A22" };
    font-size: 0.875rem;
    text-align: center;
    border: 1px solid #C9D2E7;
    width: 112px;
`;

export const Heading = styled.div`
    color: #171A22;
    font-size: 1.563rem; //25px
    font-weight: 700;
    margin: 5px 0px;
`;
export const Description = styled.div`
    color: #6A7387;
    font-size: 0.875rem;
    font-weight: 500;
`;

export const FormLabel = styled.div`
    font-size: ${ p => p.fontSize || "1rem" };
    color: #171A22;
    font-weight: 700;
    margin-bottom: 10px;
`;

export const FormDescription = styled.div`
    font-size: 0.875rem;
    font-weight: 500;
    color: #6A7387;
`;
